exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropArea.jtk-droppable {\r\n  min-width: 2rem;\r\n  min-height: 1rem;\r\n  display: none;\r\n\r\n  border: 2px dashed #ccc;\r\n  transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n}\r\n.dropArea.jtk-drag-active {\r\n  display: block;\r\n}\r\n.dropArea.jtk-drag-hover {\r\n  background: #efefef;\r\n}\r\n.dropArea.hidden {\r\n  display: none;\r\n}", ""]);

// exports
